<template>
  <section
    id="cover"
    class="te-bg-career-image co-bg-image-full relative flex flex-col items-center justify-center px-4 text-center text-co-gray-50"
  >
    <div class="relative">
      <p class="te-ribbon co-display-10 mb-6 inline-block bg-co-info-500 px-5 py-2 tracking-[.15em] md:mb-3">
        <span class="drop-shadow-[0_1px_2px_rgba(0,0,0,.3)]">受講生限定の転職支援サービス</span>
      </p>
      <h2 class="te-career-logo pb-8 md:mb-0 md:py-5">
        <img
          src="~/assets/images/Te/TeCareerAbout/Index/Cover/logo-career.svg"
          alt="テックアカデミー キャリア"
        >
      </h2>
      <p class="te-career-bottom co-display-11 co-mb-20">
        テックアカデミーで身につけたスキルが転職の武器になる<br>企業やコンサルタントからスカウトが届く
      </p>
    </div>
  </section>
</template>

<style scoped>
.co-bg-image-full {
  background-position: center;
  background-size: cover;
}

.te-bg-career-image {
  height: 450px;
  background-image: url('~/assets/images/Te/TeCareerAbout/Index/Cover/bg-career-about.jpg');
}

.te-bg-career-image::before {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: block;
  width: 100%;
  min-height: 100%;
  content: '';
  opacity: 0.75;
}

@media (max-width: 767.98px) {
  .te-ribbon {
    font-size: 0.875rem;
  }
}

@media (max-width: 575.98px) {
  .te-ribbon,
  .te-career-bottom {
    font-size: 0.75rem;
  }
}
</style>
